import { defineStore } from 'pinia'
import { ref, computed, readonly } from 'vue'
import type { IntegratorWallets, Wallet } from '@nsftx/seven-client-retail-vue-integrator'
import { getInitialWallet } from '@/modules/wallet/walletService'

export const useWalletStore = defineStore('wallet', () => {
  const wallets = ref<IntegratorWallets | null>(null)
  const activeWallet = ref<Wallet | null>(null)

  const hasMultipleWallets = computed(
    () => Array.isArray(wallets.value) && wallets.value.length > 1
  )

  const setWallets = (walletsToSet: IntegratorWallets) => {
    const previousId = activeWallet.value?.id
    wallets.value = walletsToSet

    const preserved = previousId
      ? (walletsToSet?.find(({ id }) => id === previousId) ?? null)
      : null

    activeWallet.value = preserved ?? getInitialWallet(walletsToSet) ?? null
  }

  const setActiveWallet = (walletId: string) => {
    activeWallet.value = wallets.value?.find(({ id }) => id === walletId) ?? null
  }

  return {
    activeWallet,
    wallets: readonly(wallets),
    hasMultipleWallets,
    setActiveWallet,
    setWallets
  }
})
